import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const isHome = location.pathname === '/';

  const handleAnchor = (e, hash) => {
    if (isHome) {
      e.preventDefault();
      setMenuOpen(false);
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navItems = [
    { label: 'About', to: '/about' },
    { label: 'Line Up', hash: '#lineup' },
    { label: 'Story', hash: '#story' },
    { label: 'Area', hash: '#area' },
    { label: 'Blog', to: '/blog' },
    { label: 'Contact', hash: '#contact' },
  ];

  return (
    <>
      <header className={`gc-header${scrolled ? ' gc-header--scrolled' : ''}${menuOpen ? ' gc-header--open' : ''}`}>
        <Link to="/" className="gc-header__logo">Guri Coffee</Link>
        <ul className="gc-header__nav">
          {navItems.map((item) =>
            item.to ? (
              <li key={item.label}>
                <Link to={item.to} className="gc-header__nav-link">{item.label}</Link>
              </li>
            ) : (
              <li key={item.label}>
                <a
                  href={isHome ? item.hash : `/${item.hash}`}
                  className="gc-header__nav-link"
                  onClick={(e) => handleAnchor(e, item.hash)}
                >
                  {item.label}
                </a>
              </li>
            )
          )}
        </ul>
        <button
          className={`gc-hamburger${menuOpen ? ' gc-hamburger--open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニュー"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </header>

      <div className={`gc-mobile-menu${menuOpen ? ' gc-mobile-menu--open' : ''}`}>
        <nav className="gc-mobile-menu__nav">
          {navItems.map((item) =>
            item.to ? (
              <Link
                to={item.to}
                className="gc-mobile-menu__link"
                key={item.label}
                onClick={() => setMenuOpen(false)}
              >
                {item.label}
              </Link>
            ) : (
              <a
                href={isHome ? item.hash : `/${item.hash}`}
                className="gc-mobile-menu__link"
                key={item.label}
                onClick={(e) => { handleAnchor(e, item.hash); setMenuOpen(false); }}
              >
                {item.label}
              </a>
            )
          )}
        </nav>
        <a
          href="https://guricoffee.base.shop/"
          target="_blank"
          rel="noopener noreferrer"
          className="gc-mobile-menu__shop"
        >
          Online Store
        </a>
      </div>
    </>
  );
};

export default Header;
